"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import type { DropMetadata } from "@/entities/IDrop";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import { buildTooltipId } from "@/helpers/tooltip.helpers";
interface WaveDropMetadataProps {
  readonly metadata: DropMetadata[];
}

// Component to display individual metadata items in cards
const MetadataItem: React.FC<{
  label: string;
  value: string;
}> = t0 => {
  const $ = _c(18);
  const {
    label,
    value
  } = t0;
  const isMobile = useIsMobileDevice();
  let t1;
  if ($[0] !== label || $[1] !== value) {
    t1 = buildTooltipId("metadata", label, value);
    $[0] = label;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tooltipId = t1;
  let t2;
  if ($[3] !== label) {
    t2 = <span className="tw-mr-1.5 tw-text-xs tw-font-normal tw-uppercase tw-text-iron-400">{label}:</span>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== tooltipId || $[6] !== value) {
    t3 = <span className="tw-truncate tw-text-xs tw-font-medium tw-text-iron-50" data-tooltip-id={tooltipId}>{value}</span>;
    $[5] = tooltipId;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isMobile || $[9] !== tooltipId || $[10] !== value) {
    t4 = !isMobile && <Tooltip id={tooltipId} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{value}</Tooltip>;
    $[8] = isMobile;
    $[9] = tooltipId;
    $[10] = value;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t5) {
    t6 = <div className="tw-flex tw-flex-col tw-gap-y-1.5 tw-rounded-md tw-bg-iron-800 tw-px-2 tw-py-1">{t2}{t5}</div>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default function WaveDropMetadata(t0) {
  const $ = _c(10);
  const {
    metadata
  } = t0;
  const [showAllMetadata, setShowAllMetadata] = useState(false);
  if (metadata.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      setShowAllMetadata(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleShowMore = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => {
      e_0.stopPropagation();
      setShowAllMetadata(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleShowLess = t2;
  let t3;
  if ($[2] !== metadata) {
    t3 = metadata.slice(0, 2).map(_temp);
    $[2] = metadata;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== metadata || $[5] !== showAllMetadata) {
    t4 = metadata.length > 2 && (showAllMetadata ? <>{metadata.slice(2).map(_temp2)}<button onClick={handleShowLess} className="tw-cursor-pointer tw-self-end tw-whitespace-nowrap tw-border-0 tw-bg-transparent tw-pb-1 tw-text-left tw-text-xs tw-font-medium tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-iron-300">Show less</button></> : <button onClick={handleShowMore} className="tw-cursor-pointer tw-self-end tw-whitespace-nowrap tw-border-0 tw-bg-transparent tw-pb-1 tw-text-left tw-text-xs tw-font-medium tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-iron-300">Show all</button>);
    $[4] = metadata;
    $[5] = showAllMetadata;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="tw-mt-4 tw-hidden tw-flex-col tw-gap-2 lg:tw-flex"><div className="tw-grid tw-grid-cols-2 tw-gap-2 sm:tw-grid-cols-4">{t3}{t4}</div></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp2(item_0) {
  return <MetadataItem key={item_0.data_key} label={item_0.data_key} value={item_0.data_value || ""} />;
}
function _temp(item) {
  return <MetadataItem key={item.data_key} label={item.data_key} value={item.data_value || ""} />;
}